<template>
  <div v-if="!value._delete" class="vehicle-form-grid">
    <ValidatedInput
      rules="required|min:4|max:4"
      label="Year"
      :id="`vehicleYear-${index}`"
      :value="value.year"
      :errors="errorResolver({ index, field: 'year' })"
      @input="emitChange('year', $event)"
      @change="getMakes()"
    />

    <ValidatedInput
      rules="required"
      label="Make"
      :id="`vehicleMake-${index}`"
      text-transform="capitalize"
      :value="value.make"
      :errors="errorResolver({ index, field: 'make' })"
      @change="getModels()"
      @input="emitChange('make', $event)"
      :options="makesOption"
      option-label="name"
    />

    <ValidatedInput
      rules="required"
      label="Model"
      :id="`vehicleModel-${index}`"
      text-transform="capitalize"
      :value="value.model"
      :errors="errorResolver({ index, field: 'model' })"
      @input="emitChange('model', $event)"
      :options="modelOptions"
      option-label="model"
    />

    <ValidatedInput
      label="Color"
      :id="`color-${index}`"
      text-transform="capitalize"
      :value="value.color"
      :errors="errorResolver({ index, field: 'color' })"
      @input="emitChange('color', $event)"
    />

    <ValidatedSelect
      :id="`vehicleTypeId-${index}`"
      v-model="value.vehicleTypeId"
      :options="vehicleTypes"
      :option-label-key="'name'"
      :option-value-key="'id'"
      :rules="'required'"
      :errors="errorResolver({ index, field: 'vehicleTypeId' })"
      label="Vehicle Type"
    />

    <div class="form-group">
      <label :for="`vehicleIsInoperable-${index}`">Condition*</label>
      <ValidationProvider name="Condition" rules="required" v-slot="{ errors }">
        <select
          :id="`vehicleIsInoperable-${index}`"
          :value="value.isInoperable"
          :class="{ 'form-control': true, 'is-invalid': errors[0] }"
          @input="e => emitChange('isInoperable', e.target.value)"
        >
          <option value="0">Operable</option>
          <option value="1">Not operable</option>
        </select>
        <span>{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <ValidatedInput
      rules="required|min:2"
      mask="price"
      label="Price offered"
      :id="`priceOffered-${index}`"
      :value="value.price"
      :errors="errorResolver({ index, field: 'price' })"
      @input="emitChange('price', $event)"
    />

    <ValidatedInput
      v-if="!hideDeposit"
      rules="required|min:2"
      mask="price"
      label="Deposit"
      :id="`deposit-${index}`"
      :value="value.deposit"
      :errors="errorResolver({ index, field: 'deposit' })"
      @input="emitChange('deposit', $event)"
    />

    <ValidatedInput
      label="VIN"
      :id="`vin-${index}`"
      :value="value.vin"
      text-transform="uc"
      :errors="errorResolver({ index, field: 'vin' })"
      @input="emitChange('vin', $event)"
    />

    <ValidatedInput
      label="Lot number"
      :id="`lot_number-${index}`"
      :value="value.lotNumber"
      :errors="errorResolver({ index, field: 'lotNumber' })"
      @input="emitChange('lotNumber', $event)"
    />

    <ValidatedInput
      label="Plate number"
      :id="`plateNumber-${index}`"
      :value="value.plateNumber"
      :errors="errorResolver({ index, field: 'plateNumber' })"
      @input="emitChange('plateNumber', $event)"
    />

    <div class="form-group form-actions" v-if="formLength > 1">
      <button @click.prevent="$emit('delete', index)" class="btn btn-outline-danger">
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>
</template>

<script>
import ValidatedInput from '@/components/shared/ValidatedInput'
import { apiRequest } from '@/api/apiRequest'
import { ApiClient } from '@/api/ApiClient';
import ValidatedSelect from '@/components/shared/ValidatedMultiselect.vue';

export default {
  name: 'VehicleForm',
  props: {
    value: { type: Object, required: true },
    index: Number,
    errorResolver: Function,
    vehicleTypes: Array,
    hideDeposit: Boolean,
    formLength: Number
  },
  data(){
    return {
      makesOption: [],
      modelOptions: []
    }
  },
  components: {
    ValidatedInput,
    ValidatedSelect
  },
  mounted() {
    this.getMakes()
    this.getModels()
  },
  methods: {
    emitChange(field, newValue) {
      let oldValue = this.value[field];

      if ((field === 'deposit' || field === 'price' || field === 'year') && newValue === '') {
        newValue = null;
      }

      let updated = { ...this.value, [field]: newValue };

      this.$emit('input', updated);

      if (oldValue !== newValue) {
        if (field === 'year') {
          this.makesOption = [];
          this.modelOptions = [];
          this.$emit('input', updated);
          this.getMakes();
          return;
        }

        if (field === 'make') {
          updated.model = null;
          this.modelOptions = [];
          this.$emit('input', updated);
          this.getModels();
          return;
        }
      }

      if (field === 'vin' && newValue && newValue.length === 17) {
        this.decodeVin(newValue);
      }
    },
    async decodeVin(vin) {
      const response = await apiRequest({
        path: `https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/${vin}?format=json`,
      });
      const vinData = response.data.Results[0];
      if (vinData.ErrorCode === '0') {
        const updated = {
          ...this.value,
          make: vinData.Make,
          model: vinData.Model,
          year: vinData.ModelYear,
          vin,
        };
        this.$emit('input', updated);
      } else {
        console.warn('VIN decode error:', vinData);
      }
    },
    async getMakes(){
      const resonse = await ApiClient.vehicles.makes.get({ params: { year: this.value.year } })
      if(resonse.status === 200){
        this.makesOption =  resonse.data.data
      }
    },
    async getModels(){
      const resonse = await ApiClient.vehicles.models.get({ params: { year: this.value.year, make: this.value.make } })
      if(resonse.status === 200){
        this.modelOptions =  resonse.data.data
      }
    }
  }
};
</script>

<style scoped>
.vehicle-form-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 32px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px dotted grey;
}
.form-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>
